const cdnConfigs = {
	dev: {
		// url: 'https://dev-nxl.d.nexon.io/',
		url: 'https://test-nxl.nxfs.nexon.com/',
	},
	testPre: {
		url: 'https://test-nxl.nxfs.nexon.com/',
	},
	test: {
		url: 'https://test-nxl.nxfs.nexon.com/',
	},
	pre: {
		url: 'https://pre-nxl.nxfs.nexon.com/',
	},
	prod: {
		url: 'https://nxl.nxfs.nexon.com/',
	},
};

export default cdnConfigs[process.env.NODE_ENV];
